import { render, staticRenderFns } from "./TrueOrFalsePreview.vue?vue&type=template&id=3edbf3fc&scoped=true&"
import script from "./TrueOrFalsePreview.vue?vue&type=script&lang=js&"
export * from "./TrueOrFalsePreview.vue?vue&type=script&lang=js&"
import style0 from "./TrueOrFalsePreview.vue?vue&type=style&index=0&id=3edbf3fc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edbf3fc",
  null
  
)

component.options.__file = "TrueOrFalsePreview.vue"
export default component.exports